module.exports = __webpack_public_path__ + "static/media/zen_paper_front.b2f9fe3f.png";